{ tenantType, userType } = require '@atlassiansox/analytics-web-client'
Auth = require 'db/auth'
Analytics = require('common/debug/behavioral-analytics').default
Browser = require '@trello/browser'
ClientConfig = require 'debug/client-config'
EMAUEmbedWhitelist = require 'data/emau-embed-whitelist'
{ getQueryParameter } = require 'lib/util'
trackGoogleTagManager = require 'debug/trackGoogleTagManager'

isGdprUser = document.cookie.indexOf("gdpr-user=true") != -1
hasCookieConsent = document.cookie.indexOf("gdpr-cookie-consent=accepted") != -1

options =
  appId: ClientConfig.get('appId') or 'web'
  cookieDomain: '.trello.com'
  respectDoNotTrack: true
  stateStorageStrategy: 'cookie'

if isGdprUser && !hasCookieConsent
  options.cookieLifetime = 0

window.sp? 'newTracker', 'cf', window.snowplowCloudfrontServer, options

if isGdprUser
  window.sp? 'setOptOutCookie', 'opt-out'


if Auth.isLoggedIn()
  window.sp?('setUserId:cf', Auth.myId())
  trackGoogleTagManager.push isLoggedIn: true
else
  if document.body
    window.trelloCookieConsent?()
  else
    document.addEventListener("DOMContentLoaded", window.trelloCookieConsent)
  trackGoogleTagManager.push isLoggedIn: false

emauEmbeddable = getQueryParameter('iframeSource', '') in EMAUEmbedWhitelist

if Auth.isLoggedIn() && (!Browser.isEmbeddedDocument() || emauEmbeddable)
  Analytics.setTenantInfo tenantType.NONE
  Analytics.setUserInfo userType.TRELLO, Auth.myId()
  Analytics.startUIViewedEvent()

window.dataLayer?.push inApp: true
window.sp? ->
  trackGoogleTagManager.push
    event: 'snowplow.loaded'
    snowplow:
      domain_userid: this.cf?.getDomainUserId()

  # Domain_userid saved here to use in SimpleTest
  # experiments with non-member goals, e.g. signups
  window.domain_userid = this.cf?.getDomainUserId()



// WEBPACK FOOTER //
// ./app/scripts/init/init-analytics.coffee